import { graphql } from "~/gql";

export const GET_CURRENCIES = graphql(/* GraphQL */ `
  query Currencies {
    currencies {
      code
      id
      symbol
      name
      baseCurrency
    }
  }
`);
